import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { OrderCompensationType } from '../enums/OrderCompensationType'

export class CreateUpdateCompensationEntity {
  amount?: number
  note?: string | null
  type?: OrderCompensationType
  driver?: DriverEntity | null
}
